export const defaultCompositeDeviceProfileWidgets = [
	{
		enabled: true,
		id: "access_control",
		index: 0
	},
	{
		enabled: true,
		id: "map",
		index: 1
	},
	{
		enabled: true,
		id: "files",
		index: 2
	},
	{
		enabled: true,
		id: "cameras",
		index: 3
	}
];
